import { isDataSourceInfo } from '../../utils.js';
import { createAttribute } from '../attributes.js';
import { createDateDimension, createDimension } from './dimensions.js';
/**
 * Function to convert data source fields to dimensions.
 *
 * @param fields - The data source fields to convert.
 * @param dataSource - The data source title.
 * @returns - The dimensions created from the data source fields.
 * @internal
 */
export function getDimensionsFromDataSourceFields(fields, dataSource) {
    const attributeEntries = fields.map((field) => createAttributeEntry(field, dataSource));
    const groupedConfigs = groupAttributesByDimension(attributeEntries);
    return Object.values(groupedConfigs).map((config) => createDimension(config));
}
/**
 * Given a DataSourceField and the data source title, creates an attribute entry
 * that includes the dimension name, attribute name, and the attribute itself.
 */
const createAttributeEntry = (field, dataSource) => {
    const dimensionId = field.table;
    const dimensionName = field.tableTitle || dimensionId;
    const attributeId = field.id;
    const attributeName = field.title || attributeId;
    const dataSourceConfig = isDataSourceInfo(dataSource)
        ? dataSource
        : { title: dataSource, live: false };
    const attribute = field.dimtype === 'datetime'
        ? createDateDimension({
            name: attributeName,
            expression: attributeId,
            dataSource: dataSourceConfig,
            description: field.description,
        })
        : createAttribute({
            name: attributeName,
            type: field.dimtype === 'text' ? 'text-attribute' : 'numeric-attribute',
            expression: attributeId,
            dataSource: dataSourceConfig,
            description: field.description,
        });
    return {
        dimension: {
            id: dimensionId,
            name: dimensionName,
            description: field.tableDescription,
        },
        attribute,
    };
};
/**
 * Groups an array of attribute entries by their dimension name.
 * Returns an object whose keys are dimension names and values are configuration objects
 * that can be passed to createDimension.
 */
const groupAttributesByDimension = (entries) => entries.reduce((acc, { dimension, attribute }) => {
    const dimensionConfig = acc[dimension.name] || {
        name: dimension.name,
        expression: dimension.id,
        description: dimension.description,
    };
    return Object.assign(Object.assign({}, acc), { [dimension.name]: Object.assign(Object.assign({}, dimensionConfig), { [attribute.name]: attribute }) });
}, {});
//# sourceMappingURL=utils.js.map